export default "__VITE_ASSET__CY$kDi84__"